import React from "react";

// Generic modal component
export default function Modal({ isOpen, onClose, children }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-40">
      <div
        className="relative bg-white rounded-2xl shadow-2xl w-[90vw] max-w-2xl md:w-[600px] p-0 m-2 flex flex-col"
        style={{ maxHeight: "95vh" }}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-50 text-gray-500 hover:text-gray-700 text-2xl h-10 w-10 flex items-center justify-center rounded-full focus:outline-none bg-transparent border-none p-0 transition-colors"
          aria-label="Close"
          style={{ boxShadow: "none" }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <div className="w-full flex-1 overflow-y-auto px-6 py-5">{children}</div>
      </div>
    </div>
  );
}
